<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          :rules="[rules.required]"
          v-model="crud.audio_text.title"
          label="Title"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="crud.audio_text.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea rows="3" v-model="crud.audio_text.description" label="Description"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="crud.audio_text.audio_file"
          label="Audio"
          show-size
          prepend-icon
          accept="audio/*"
          append-icon="mdi-music"
        >
          <template v-slot:selection v-if="typeof crud.audio_text.audio_file === 'string'"
            >You already saved a file. Click to save a new one...</template
          >
        </v-file-input>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12">
        <v-card-title>
          <span class="title">Comprehension</span>
        </v-card-title>
      </v-col>
      <v-col cols="12">
        <v-text-field
          :rules="[rules.required]"
          v-model="crud.comprehension.question_group.questions[0].title"
          label="Question Title"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <span class="font-weight-semibold">
          Question Here
          <v-icon size="20" class="mb-1" color="black">mdi-arrow-down</v-icon>
        </span>
        <app-editor
          ref="content"
          v-model="crud.comprehension.question_group.questions[0].content"
        />
      </v-col>
      <v-col cols="12">
        <span class="font-weight-semibold">
          Question Answer Here
          <v-icon size="20" class="mb-1" color="black">mdi-arrow-down</v-icon>
        </span>
        <app-editor
          ref="answer"
          v-model="crud.comprehension.question_group.questions[0].good_answer"
        />
      </v-col>
      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto"
        >Save</v-btn
      >
    </v-row>
  </v-form>
</template>
<script>
import rulesMixin from "@/mixins/rulesMixin";
import restoreMixin from "@/mixins/restoreMixin";
import { getAudioText, postAudioText, postComprehension, postQuestions } from "@/api/api";
import Editor from "@/components/Utils/Editor.vue";

export default {
  components: {
    appEditor: Editor,
  },
  props: {
    direction: {
      required: false,
      default: "",
      type: String,
    },
  },
  mixins: [rulesMixin, restoreMixin],
  data() {
    return {
      loading: false,
      crud: {
        audio_text: {},
        comprehension: {
          question_group: {
            name: "Comprehension",
            questions: [
              {
                question_file: undefined,
                good_answer: {
                  type: "doc",
                  content: [
                    {
                      type: "paragraph",
                      content: [
                        {
                          type: "text",
                          text: "Write your questions' answers here...",
                        },
                      ],
                    },
                  ],
                },
                content: {
                  type: "doc",
                  content: [
                    {
                      type: "paragraph",
                      content: [
                        {
                          type: "text",
                          text: "Write your questions here...",
                        },
                      ],
                    },
                  ],
                },
              },
            ],
          },
        },
      },
    };
  },
  computed: {
    teacher_lesson() {
      return this.$store.getters["admin/teacher_lesson"];
    },
    practice() {
      return this.$store.getters["admin/practice"];
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        let audio_text = { ...this.crud.audio_text };
        let comprehension = { ...this.crud.comprehension };
        let direction;

        if (this.direction) {
          audio_text.audio_text_step = this.practice.audio_text_step;
          comprehension.audio_text_step = this.practice.audio_text_step;
          direction = this.direction;
        } else {
          audio_text.audio_text_step = this.teacher_lesson.audio_text_step;
          comprehension.audio_text_step = this.teacher_lesson.audio_text_step;
          direction = "teach";
        }

        let response = await postAudioText(audio_text, direction);
        this.crud.audio_text.uuid = response.data.uuid;

        response = await postComprehension(comprehension, direction);
        this.crud.comprehension.uuid = response.data.uuid;

        if (response.data.question_group.uuid) {
          this.crud.comprehension.question_group.uuid = response.data.question_group.uuid;
        } else this.crud.comprehension.question_group.uuid = response.data.question_group;

        let newQuestions = JSON.parse(JSON.stringify(this.crud.comprehension.question_group));

        newQuestions.questions[0].good_answer = JSON.stringify(
          newQuestions.questions[0].good_answer,
        );
        newQuestions.questions[0].content = JSON.stringify(newQuestions.questions[0].content);

        const questions = await postQuestions(newQuestions);

        this.crud.comprehension.question_group.questions[0].uuid = questions.questions[0].uuid;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loading = false;
    },
    async create() {
      let uuid = "";
      try {
        let direction;

        if (this.direction) {
          uuid = this.practice.audio_text_step;
          direction = "practice";
        } else {
          uuid = this.teacher_lesson.audio_text_step;
          direction = "teach";
        }
        if (uuid) {
          const response = await getAudioText(uuid, direction);
          this.crud.uuid = response.data.uuid;
          if (response.data.audio_text) this.crud.audio_text = response.data.audio_text;
          if (response.data.comprehension) {
            this.crud.comprehension = response.data.comprehension;
            this.crud.comprehension.question_group.questions[0].good_answer = JSON.parse(
              this.crud.comprehension.question_group.questions[0].good_answer,
            );
            this.crud.comprehension.question_group.questions[0].content = JSON.parse(
              this.crud.comprehension.question_group.questions[0].content,
            );
            this.$refs.answer.editor.setContent(
              this.crud.comprehension.question_group.questions[0].good_answer,
            );
            this.$refs.content.editor.setContent(
              this.crud.comprehension.question_group.questions[0].content,
            );
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
  created() {
    this.create();
  },
};
</script>
